import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api/axios";
import DaumPostcode from "../../components/widgets/DaumPostcode";
import TmapGeocoder from "../../components/viewer/tmap/TmapGeocoder";

const ProjectInfoManage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const [projectInfo, setProjectInfo] = useState({
    name: "",
    project_id: "",
    coord: null,
    address: "",
    extra_address: "",
    detail_address: ""
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // 🔹 최초 렌더링 시 프로젝트 정보 불러오기
  useEffect(() => {
    api
      .get(`/projects/read/${projectId}/`)
      .then((res) => {
        const { name, project_id } = res.data;
        setProjectInfo({ name, project_id });
      })
      .catch((err) => {
        console.error("프로젝트 불러오기 실패:", err);
        alert("프로젝트 정보를 불러오는 데 실패했습니다.");
      })
      .finally(() => setLoading(false));
  }, [projectId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    const detailAddress = document.getElementById("detailAddress")?.value || "";
    const updatedProjectInfo = {
      ...projectInfo,
      detail_address: detailAddress,
    };
    console.log("저장할 프로젝트 정보:", updatedProjectInfo);

    setSaving(true);
    api
      .put(`/projects/update/${projectId}/`, updatedProjectInfo)
      .then(() => {
        alert("저장 완료되었습니다.");
        navigate("/admin/");
      })
      .catch((err) => {
        console.error("저장 실패:", err);
        alert("저장에 실패했습니다.");
      })
      .finally(() => setSaving(false));
  };

  if (loading) return <div>불러오는 중...</div>;

  const handlePostcodeChange = ({ address, extra_address }) => {
    setProjectInfo((prev) => ({
      ...prev,
      address,
      extra_address,
    }));
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>프로젝트 정보 수정</h2>
      <div>
        <label>사업명: </label>
        <input
          type="text"
          name="name"
          value={projectInfo.name}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>사업 ID: </label>
        <input
          type="text"
          name="project_id"
          value={projectInfo.project_id}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>현장 주소</label>
        <DaumPostcode text="주소 검색" onAddressChange={handlePostcodeChange} />
      </div>
      <button className="btn-blue" onClick={handleSave} disabled={saving}>
        {saving ? "저장 중..." : "저장"}
      </button>

      <div className="p-4">
        <h1 className="text-xl font-bold mb-4">현장 위치</h1>
        <TmapGeocoder
          address={projectInfo.address}
          onGeocode={({ lat, lon }) => {
            setProjectInfo((prev) => ({
              ...prev,
              lat_coord: parseFloat(lat),
              lon_coord: parseFloat(lon)
            }));
          }}
        />
      </div>
    </div>
  );
};

export default ProjectInfoManage;
